export default {
  // 2-1
  GET_APPLY_SPCDATA(state, data) {
    state.sfactory_list = data.data.spcFacList;
    state.workarea_list = data.data.workArea;
    state.reason_list = data.data.specialReason;
    state.worktype_list = data.data.highRisk;
  },
  //GET_SIGNER_LIST(state, data) {
  //  state.signer_list = data.data;
  //},
};
